<!--购物车-->
<template>
    <div>

<!-- 购物车 -->
  <div class="shoppingCart wrapper_1200">
    <div class="title wrapper_1200">
      <nuxt-link class="home" to="/">首页 > </nuxt-link>购物车
    </div>
    <div class="cartList" v-if="businessList.length">
      <div class="header acea-row row-middle">
        <div class="allSelect acea-row row-center-wrapper" @click="allChecked">
          <div class="checkbox-wrapper">
            <label class="well-check">
              <input
                type="checkbox"
                name=""
                value=""
                v-model="businessList[0].checked"
                @click="onBusinessCheckChange(0, businessList[0].checked)"
              />
              <i class="icon"></i>
              <span class="checkAll">全选</span>
            </label>
          </div>
        </div>
        <div class="info acea-row row-center-wrapper">商品信息</div>
        <div class="price acea-row row-center-wrapper">单价</div>
        <div class="num acea-row row-center-wrapper">数量</div>
        <div class="money acea-row row-center-wrapper">金额</div>
        <div class="operate acea-row row-center-wrapper">操作</div>
      </div>
      <div class="body">
        <div class="item acea-row row-middle" v-for="(item, index) in businessList[0].goods_items" :key="index">
          <div class="allSelect acea-row row-center-wrapper">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input
                  type="checkbox"
                  name=""
                  value=""
                  :checked="item.checked" 
                @change="onGoodsCheckChange(0,index)"
                />
                <i class="icon"></i>
              </label>
            </div>
          </div>
          <div class="info acea-row row-middle">
            <div class="pictrue"> 
              <img :src='item.pic_url'>
            </div>
            <div class="text">
              <div class="name line2">{{item.title}}</div>
              <div class="infor">属性：{{item.sku_formart}}</div>
              
            </div>
          </div>
          <div class="price acea-row row-center-wrapper">¥{{item.price}} 
          </div>
          <div class="num acea-row row-center-wrapper">
            <div class=" ">
                <el-input-number v-model="item.count" @change="onGoodsCountChange(item)" :min="1" :max="item.stock" label=""></el-input-number>
</div>
            
          </div> 
          
          <div class="money acea-row row-center-wrapper font-color">¥{{item.total_price}} </div>
          <div class="operate acea-row row-center-wrapper" @click="onDelete(item)"><span class="iconfont icon-shanchu"></span></div>
        </div>
      </div>
    </div> 
    <div class="footer acea-row row-between-wrapper" v-if="businessList.length || businessList.length">
      <div class="num">已选 {{refundNum}} 件商品</div>
      <div class="acea-row row-middle">
        <div class="total">合计：<span class="font-color">¥{{totalPrice}}</span></div>
        <div class="bnt bg-color" @click="submit">去结算</div>
      </div>
    </div>
    <div class="noCart" v-if="!businessList.length && !businessList.length">
      <div class="pictrue"><img src="~@/assets/images/noCart1.png"></div>
      <div class="tip">亲，购物车还是空的哟~</div>
      <nuxt-link to="/goods_cate" class="goIndex">继续逛</nuxt-link>
    </div>

  

  </div>  

 
    </div>
</template>
<style scoped lang="scss">
  
.grey{
  color: #D0D0D0!important;
}
.shoppingCart{
  cursor: pointer;
  .noCart{
    text-align: center;
    .pictrue{
      width: 274px;
      height: 174px;
      margin: 111px auto 0 auto;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .tip{
      font-size: 14px;
      color: #969696;
      margin-top: 20px;
    }
    .goIndex{
      width: 90px;
      height: 35px;
      border: 1px solid #282828;
      border-radius: 6px;
      text-align: center;
      line-height: 35px;
      font-size: 14px;
      color: #282828;
      margin: 24px auto 100px auto;
      display: block;
    }
  }
  .title{
    height: 59px;
    line-height: 59px;
    color: #999999;
    .home{
      color: #282828;
    }
  }
  .cartList{
    .header{
      height: 54px;
      background: #F9F9F9;
    }
    .allSelect{
      width: 100px;
      position: relative;
      .checkAll{
        margin-left: 30px;
      }
    }
    .info{
      width: 400px;
      padding-left: 30px;
    }
    .price{
      width: 215px;
    }
    .num{
      width: 150px;
    }
    .money{
      width: 270px;
    }
    .body{
      border: 1px solid #EFEFEF;
      border-top: 0;
      .item{
        &~.item{
          border-top:1px dotted #E2E2E2;
        }
        height: 170px;
        .info{
          .pictrue{
            width: 90px;
            height: 90px;
            margin-right: 14px;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .text{
            width: 264px;
            .infor{
              margin-top: 10px;
              font-size: 12px;
              color: #D0D0D0;
            }
          }
        }
        .price{
          font-size: 16px;
        }
        .num{
          .iconfont{
            width: 40px;
            height: 36px;
            line-height: 36px;
            border: 1px solid #D3D3D3;
            text-align: center;
            color: #707070;
            background-color: #fff;
          }
          .numCon{
            width: 54px;
            height: 36px;
            border:0;
            border-top:1px solid #D3D3D3;
            border-bottom:1px solid #D3D3D3;
            font-size: 15px;
            color: #5A5A5A;
            text-align: center;
            line-height: 36px;
            outline: none;
          }
        }
        .money{
          font-size: 16px;
        }
        .operate{
          color: #D0D0D0;
          .iconfont{
            font-size: 20px;
          }
        }
      }
    }
  }
  .invalid{
    margin-top: 20px;
    border-top: 1px solid #EFEFEF;
  }
  .footer{
    height: 82px;
    background: #F9F9F9;
    margin-top: 60px;
    padding-left: 30px;
    margin-bottom: 30px;
    .total{
      font-size: 16px;
      .font-color{
        font-size: 22px;
        font-weight: bold;
      }
    }
    .bnt{
      width: 160px;
      height: 82px;
      text-align: center;
      line-height: 82px;
      font-size: 18px;
      color: #fff;
      margin-left:30px;
    }
  }
}
</style>

<script>
    import TabBar from '@/components/TabBar.vue';
    import LoginDialog from '@/components/LoginDialog.vue';

    import Vue from 'vue'
    import {
        Stepper,
        Checkbox,
        Toast
    } from 'vant';

    export default {
        name: 'Cart',
        components: {
            TabBar,
            [Checkbox.name]: Checkbox,
            [Stepper.name]: Stepper,
            Toast,
            LoginDialog
        },
        data: function () {
            return {
                loginShow: false,
                allChecked: true,
                checkedIds: [],
                countmoney:0,//购物车产品总价；
                refundNum:0,
                isEdit: false,
                goods: {},
                isAllSelect: false,
                checkedIds: [],

                businessList: [],
                totalPrice: 0,

                isAllButton: 1,
                isBusinessButton: 1
            }
        },
        filter: {},
        mounted() {
            document.title = '购物车';
            this.getCartDetail()
        },
        destroyed() {
        },
        methods: {
            // 获取购物车所有数据
            getCartDetail: function () {
                let that = this;
                this.$api.get('/api/cart/detail', {}, res => {
                    that.businessList = res.data.list
                    that.totalPrice = res.data.total_price
                }, (res) => {
                  console.log('getCartDetail',res)
                    if (res.code == 401 || res.code == 402) {
                      rbLink({
                        name:'login'
                      })
                      return ;
                
                    } else {
                        Toast(res.msg)
                    }
                })
            },

            loginSuccess(res) {
                console.log('-------登录成功--------', res);
                this.loginShow = false;
                this.getCartDetail()
            },

            loginCancel() {
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },

            // 全选和全不选
            onAllCheckChange() {

                let that = this;
                let change = !that.allChecked

                that.businessList.map(business => {
                    business.checked = change;
                    business.goods_items.map(goods => {
                        goods.checked = change;
                    })
                });

                that.priceCompute()
            },

            onEdit: function () {
                let that = this;
                that.isEdit = true;
            },

            onEditComplete: function () {
                let that = this;
                that.isEdit = false;

                console.log(that.totalPrice)
            },

            // 改变基地的选中状态
            onBusinessCheckChange(bindex, status) {
                //改变goods选择状态
                console.log(status)
                let that = this;

                that.businessList[bindex].ckecked = !status

                that.businessList[bindex].goods_items.map(goods => {
                    goods.checked = !status;
                })

                that.checkAllCheck()
                that.priceCompute()
            },

            // 改变商品的选中状态
            onGoodsCheckChange(bindex, gindex) {
                let that = this;
                let status = !that.businessList[bindex].goods_items[gindex].checked;
                that.businessList[bindex].goods_items[gindex].checked = status;
                console.log('that.businessList[bindex].goods_items[gindex]',that.businessList[bindex].goods_items[gindex])

                //改变business全选状态
                if (that.businessList[bindex].goods_items.filter(goods => {
                    return goods.checked == false
                }).length > 0) {
                    // console.log(that.businessList[bindex])

                    that.businessList[bindex].checked = false;

                } else {
                    that.businessList[bindex].checked = true;

                }
                that.checkAllCheck();
                that.priceCompute();
            },

            // 更改商品数量
            onGoodsCountChange: function (item ) {
                let that = this;
                this.$api.get('/api/cart/edit', {
                    goods_id: item.goods_id,
                    sku_id: item.sku_id,
                    count: item.count,
                }, (res) => {

                }, (res) => {
                    Toast(res.msg)
                })

                that.priceCompute();
            },

            // 检查全选
            checkAllCheck() {
                //确定全选状态
                let that = this;
                if (that.businessList.filter(goods => {
                    return goods.checked == false
                }).length > 0) {
                    // change事件自动触发 checkbox
                    that.allChecked = false;
                } else {
                    that.allChecked = true;
                }

            },

            // 计算价格
            priceCompute() {
                //计算价格
                let that = this;
                let totalPrice = 0;
                that.businessList.map(business => {
                    business.goods_items.map(goods => {
                        if (goods.checked) {
                            totalPrice += goods.price * goods.count
                            goods.total_price = goods.price * goods.count
                        }
                    })
                });
                console.log('totalPrice',totalPrice)
                that.totalPrice = totalPrice
            },

            // 删除数据
            onDelete(item) {
                let that = this;
                let goods_items = []; 
 
                this.$api.post('/api/cart/removeList', {goods_items: [item]}, res => {
                    that.getCartDetail();
                })
 
                that.priceCompute();
                console.log(that.totalPrice)
            },
            // 清空购物车
            onEmpty() {
                let that = this;
                this.$api.post('/api/cart/removeAll', {}, (res) => {
                });

                that.businessList = []
                that.priceCompute();
            },

            // 结算
            submit: function () {
                let that = this;
                let goods_items = [];
                let businessList = that.businessList;
                businessList.map((business, bindex) => {
                    var deleteCount = 0;
                    business.goods_items.map((goods, gindex) => {
                        if (goods.checked) {
                            goods_items.push({
                                goods_id: goods.goods_id,
                                sku_id: goods.sku_id,
                                count: goods.count,
                            });
                        }
                    });
                });
                if (goods_items.length == 0) {
                    Toast('请至少选择一款商品');
                    return false;
                }
                localStorage.setItem('order_check_goods_items', JSON.stringify(goods_items));
                this.$router.push({path: '/orderpay'})
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Cart.vue?515a2fe3